import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, CircularProgress } from '@mui/material';
import { useLanguage } from '../../../../../context/LanguageContext';

interface DeleteConfirmModalProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    isLoading?: boolean;
    title?: string;
    message?: string;
}

const DeleteConfirmModal = ({ 
    open, 
    onClose, 
    onConfirm, 
    isLoading = false,
    title,
    message,
}: DeleteConfirmModalProps) => {
    const { t } = useLanguage();

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle>
                {title || t('common.confirmDelete')}
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {message || t('common.confirmDeleteMessage')}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={isLoading}>
                    {t('common.cancel')}
                </Button>
                <Button 
                    onClick={onConfirm} 
                    variant="contained" 
                    color="error"
                    disabled={isLoading}
                    startIcon={isLoading ? <CircularProgress size={20} /> : null}
                >
                    {isLoading ? t('common.deleting') : t('common.delete')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteConfirmModal;
